var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigninYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 467.2 423.6",
    style: {
      enableBackground: "new #ffbc2d"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbc2d",
    d: "M233.3,266.2c-44.6-0.5-80.8-36.8-80.5-81c0.3-44.4,36.6-80.4,81.1-80.3c44.3,0.1,80.7,36.6,80.5,80.8 C314.2,230,277.3,266.7,233.3,266.2 M457.1,166.3C425.9,62.9,327.9-7.4,216.3,0.6C110.4,8.2,17.6,89.2,2.2,202.7 c-6.8,50.2,2.1,97.9,26.5,142.5c17,31.1,39.9,56.9,69.7,78.4c0-18.1-0.1-34.8,0-51.4c0.4-44.5,34.5-78.6,79.1-78.8 c37.3-0.2,74.6-0.1,111.9,0c5.9,0,12,0.5,17.7,1.8c37.2,8.8,61.3,39.3,61.6,77.4c0.1,16.5,0,33,0,50.4 C442.7,372.2,488.6,270.6,457.1,166.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninYellow);
export default __webpack_public_path__ + "static/media/signin_yellow.906bd0c63964efe9c7c66ec1e6e82c31.svg";
export { ForwardRef as ReactComponent };